import bigDataLog from '@/utils/bigDataLog'
import {
    addDriverApprovalRecord,
    editDriverApprovalRecord,
    addDriverPrivilege,
    editDriverPrivilege,
    getDriverApproveDetail,
    singleDriver,
    checkWPH,
    supplierDriverCarApprovalInfo,
} from '../../../../../../api/register/driver.js'
import { DELEGATE_TYPE } from './newUploadVersion/config.js'
import { driverPublicForm } from './addOrEditDialogForm.js'
import { COMPANY } from '../../../../../../constant/constant.js'
export default {
    // 新增窗口打开时处理一些逻辑
    dealWithOpenLogic() {
        const isSupplier = this.$store.state.supplier
        const propertyNature = isSupplier ? isSupplier.propertyNature : this.propertyNature
        this.isLegalPersonSupplier = propertyNature === COMPANY
        this.handleJudge(this.id)
    },
    // // 切换新旧版显示
    // switchVersion() {
    //     this.isNewUploadVersion = !this.isNewUploadVersion;
    // },
    // 预览文件
    handlePreviewFile(obj) {
        this.rowData = obj.rowData
        this.attachmentList = obj.allAttachmentList
        this.attachmentShow = true
    },
    // 校验委派函是否正确
    handleCheckWPH(downUrl) {
        return checkWPH(downUrl)
    },
    dealWithReqParams(params) {
        const reqParams = JSON.parse(JSON.stringify(params))
        // 如果委派函不选中线上和线下，那么签署人、委派函文件、委派函日期都传空
        if ([undefined, null, ''].includes(reqParams.delegateOnline)) {
            [
                'delegateFileId',
                'delegateFileName',
                'delegateFileUrl',
                'delegateEndTime',
                'delegateStartTime',
                'stamperCode',
                'stamperName',
            ].forEach(k => {
                reqParams[k] = ''
            })
        }
        // 委派函选择了线下，传委派函信息，否则传空
        ['delegateFileId', 'delegateFileName', 'delegateFileUrl', 'delegateFileTemUrl'].forEach(k => {
            reqParams[k] = params.delegateOnline === DELEGATE_TYPE.OFFLINE ? params[k] : ''
        })
        // 委派函选择了线上，传签署人信息，否则传空
        ;['stamperCode', 'stamperName'].forEach(k => {
            reqParams[k] = params.delegateOnline === DELEGATE_TYPE.ONLINE ? params[k] : ''
        })
        reqParams.paramFieldList.forEach(v => {
            v.afterValue = params[v.fieldName]
        })
        return reqParams
    },
    async handleSubmit(params, needExamine) {
        const reqParams = this.dealWithReqParams(params)
        // 委派函是否正确标识
        let flag = false
        // 法人司机选择了线下，就要校验上传的委派函是否正确
        if (this.isLegalPersonSupplier && params.delegateOnline === DELEGATE_TYPE.OFFLINE) {
            if (reqParams.delegateFileUrl) {
                this.loading = true
                await checkWPH(params.delegateFileUrl)
                    .then(res => {
                        if (res && +res.code === 0) {
                            flag = true
                        }
                    })
                    .catch(err => {})
                    .finally(() => {
                        this.loading = false
                    })
            } else {
                flag = false
            }
        } else {
            flag = true
        }
        if (!flag) {
            return false
        }
        const reqMethod = needExamine
            ? params.driverId
                ? editDriverApprovalRecord
                : addDriverApprovalRecord
            : params.driverId
                ? editDriverApprovalRecord
                : addDriverApprovalRecord
                // console.log(reqParams.paramFieldList,'5=5=5=5=5=')
                // return
        this.loading = true
        reqMethod(reqParams)
            .then(res => {
                if (res && +res.code === 0) {
                    this.handleRecover()
                }else if(res && res.code === 'LSRM25081402'){
                    this.$alert(res.msg, '提示', {
                        customClass: 'submit-warn-dialog',
                    });
                }
            })
            .finally(() => {
                this.loading = false
            })
    },
    // 新版本提交
    handleNewVersionSubmit() {
        this.$refs.newUploadVersion.validateForm(this.handleSubmit)
        bigDataLog.sendDetailMessageByKey('bigData-btn-d-submitNew')
    },
    // 处理新版页面一些逻辑
    dealWithNewUploadVersionPageLogic() {
        if (this.$refs.newUploadVersion) {
            this.$refs.newUploadVersion.resetForm() // 重置表单数据
        }
    },
    radioChange(val) {
        this.form.delegateStartTime = ''
        this.form.delegateEndTime = ''
        this.rules.stamperCode[0].required = val === DELEGATE_TYPE.ONLINE
        this.rules.delegateFileName[0].required = val === DELEGATE_TYPE.OFFLINE
        this.rules.delegateStartTime[0].required = val === DELEGATE_TYPE.OFFLINE || val === DELEGATE_TYPE.ONLINE
        this.rules.delegateEndTime[0].required = val === DELEGATE_TYPE.OFFLINE || val === DELEGATE_TYPE.ONLINE
    },
    detaliSearch(advanceCascade) {
        const isSupplier = this.$store.state.supplier
        const supplierCode = isSupplier ? isSupplier.supplierCode : this.$route.query.supplierCode
        this.$refs.advanceDialog.show(true, advanceCascade, { supplierCode })
    },
    // 选中高级组件值后回调
    detaliSearchSure(data) {
        Object.keys(data).forEach(k => {
            this.$set(this.form, k, data[k])
        })
    },
    // 重置高级组件
    resetAdvanceValue(code, name) {
        this.$set(this.form, code, '')
        this.$set(this.form, name, '')
    },
    // 新版页面初始化
    newUploadVersionInitData() {
        // 旧版已去除，无需判断 isNewUploadVersion
        // if (this.isNewUploadVersion) {
        //     this.$nextTick(() => {
        //         this.$refs.newUploadVersion.isApprove = this.approve;
        //         this.$refs.newUploadVersion.radioChange(this.form.delegateOnline);
        //         this.$refs.newUploadVersion.initFormData(this.form);
        //     });
        // }
        this.$nextTick(() => {
            this.$refs.newUploadVersion.isApprove = this.approve
            this.$refs.newUploadVersion.radioChange(this.form.delegateOnline)
            this.$refs.newUploadVersion.initFormData(this.form)
        })
    },
    // 获取审批详情数据
    getApproveDetail(id) {
        this.title = '审批详情'
        getDriverApproveDetail(id).then(res => {
            if (res && +res.code === 0) {
                [
                    'approvalUserName',
                    'approvalStatus',
                    'commitTime',
                    'approvalOpinion',
                    'approvalTime',
                    'commitUserCode',
                    'headquartersApprovalName',
                    'fdId',
                ].forEach(k => {
                    this.approveInfo[k] = res.data[k]
                })
                this.approveInfo.approvalStatusText = this.dict['SRM_AUDIT_STATUS'][res.data.approvalStatus]
                this.approveInfo.auditTypeText = this.dict['SRM_DRIVER_AUDIT_TYPE'][res.data.auditType]
                this.approveInfo.createSystemSourceText = this.dict['SRM_REGISTER_SOURCE'][res.data.createSystemSource]
                this.approveInfo.approvalModeText = this.dict['SRM_DRIVER_CAR_APPROVAL_MODE'][res.data.approvalMode]
                this.approveInfo.businessTypeText = this.dict['SRM_BUSYNESS_TYPE_BACKGROUND'][res.data.businessType]
                this.form = res.data
                // 法人供应商
                if (this.isLegalPersonSupplier) {
                    this.form.delegateOnline = this.form.delegateOnline || DELEGATE_TYPE.ONLINE
                }
                this.handleGetAllAttachmentList()
                if (this.$refs['form']) {
                    this.$refs['form'].resetFields()
                }
                this.newUploadVersionInitData()
                this.supplierDriverCarApprovalInfo()
            }
        })
    },
    supplierDriverCarApprovalInfo(){
        this.$set(this.approveInfo, '_approvalName', '' )
        this.$set(this.approveInfo, '_headquartersApprovalName', '' )
        if(this.approveInfo.fdId){
            supplierDriverCarApprovalInfo(this.approveInfo.fdId).then(res => {
                if (res && res.code === '0') {
                    this.$set(this.approveInfo, '_approvalName', res.data.approvalName )
                    this.$set(this.approveInfo, '_headquartersApprovalName', res.data.headquartersApprovalName )
                }
            })
        }
    },
    // 获取编辑详情数据
    getEditDetail(id) {
        this.title = '编辑'
        singleDriver(id).then(res => {
            if (res && +res.code === 0) {
                this.form = res.data
                // 法人供应商
                if (this.isLegalPersonSupplier) {
                    this.form.delegateOnline = this.form.delegateOnline || DELEGATE_TYPE.ONLINE
                    this.delegateOnline = this.form.delegateOnline
                }
                if (this.form.delegateFileName) {
                    this.delegateDisabled = false
                }
                this.handleGetAllAttachmentList()
                if (this.$refs['form']) {
                    this.$refs['form'].resetFields()
                }
                this.newUploadVersionInitData()
            }
        })
    },
    // 审批、编辑、新增 数据处理
    handleJudge(id) {
        if (this.approve) {
            this.getApproveDetail(id)
        } else if (id) {
            this.getEditDetail(id)
        } else {
            this.title = '新增'
            this.form = JSON.parse(JSON.stringify(driverPublicForm))
            if (this.$refs['form']) {
                this.$refs['form'].resetFields()
            }
            this.form.delegateOnline = this.isLegalPersonSupplier ? DELEGATE_TYPE.ONLINE : DELEGATE_TYPE.OFFLINE
            this.newUploadVersionInitData()
        }
    },
}
